import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentPillClickedObject } from './useTrackAgentPillClicked.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type { WorkspaceAgentPillClickedObject } from './useTrackAgentPillClicked.meta';

export type UseTrackAgentPillClickedParams = {
  object: WorkspaceAgentPillClickedObject;
  object_count: number;
  object_name: string;
};

export const useTrackAgentPillClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentPillClicked = useCallback(
    (params: UseTrackAgentPillClickedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentPillClicked };
};
